/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import cloneDeep from "lodash.clonedeep";
import { DatePicker, Drawer } from "antd";
import ReactEcharts from "../Echarts/Echarts";
import NoRecordComponent from "../Utils/NoRecords";
import localStorage from "../../../utils/localStorage";
import StyledTable from "../../../commons/styles/table";
// import { getThemeValue } from "../../../commons/styles/dynamicValues";
import { API_FILE, API_TRENDS, IPAddress, REPORTS } from "../../../commons/api";
import dayjs from "dayjs";
// import moment from "moment-timezone";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const { RangePicker } = DatePicker;

const Line = (props) => {
  const [option, setOption] = useState({});
  // const [data, setData] = useState([]);
  // const [range, setRange] = useState([]);
  const [celd, setCeld] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [visible, setVisible] = useState(false);
  const [reportName, setReportName] = useState("");
  // const [reportData, setReportData] = useState("");
  // const [errorInAPI, setErrorInAPI] = useState(false);
  // const [noDataInDB, setNoDataInDB] = useState(false);
  // const [isPreparing, setIsPreparing] = useState(true);
  var graphType = props.graphType;
  let viewType = props.viewType;
  let selectedType = props.selectedType || 'Device';

  const [momentRange, setMomentRange] = useState([]);
  // let PanelData = props.panelData ||{};


  useEffect(() => {
    prepareData();
    setReportName(reportName);
  }, [reportName]);
  useEffect(() => {
    if (
      graphType === props.graphType ||
      panelData !== props.panelData
      // viewType !== props.viewType 
      // translationCache !== props.translationCache
    ) {
      prepareData();
    }
  }, [props.graphType, props.panelData, props.selectedType]);


  dayjs.extend(utc);
  dayjs.extend(timezone);

  const getReportNametoDownload = async (excelData, type, viewType, SelectedDate, trendIndex, param) => {

    let { translationCache } = props;
    let Consumption = translation("Trend");
    if (viewType === "Multiple" && (type === "timeRange" || type === "timeWithSelectionType")) {
      Consumption = param ? `${translation(param)}${trendIndex}` : translation("Trend");
    } else if (viewType === "Multiple") {
      Consumption = param ? translation(param) : translation("Trend");
    }
    let payload = {
      PortName: "Rubus",
      Name: type && type ? translation(type) : translation("Trend"),
      Consumption,
      Data: excelData || [],
      ReportType: "singleHierarchy",
      GeneratedDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      SelectedDate: dayjs.utc(SelectedDate.From).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:ss') +
        '~' +
        dayjs.utc(SelectedDate.To).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:ss'),
      SelectionType: "dateRange",
      IsTranslate: translationCache && translationCache["GeneratedDate"] ? true : false,
      translationList: {
        GeneratedDate: translation("GeneratedDate"),
        SelectedDate: translation("SelectedDate"),
      },
    };
    let siteId = localStorage.get("currentSite");
    let accessToken = localStorage.get("accessToken");
    let options = {
      method: "POST",
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      data: JSON.stringify(payload),
    };
    return axios(options)
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        return "";
      });
  };


  const prepareData = async () => {
    let { panelData } = props;
    let option = cloneDeep(getOption(panelData));
    let xaxis = [];
    let series = [];
    let legendsdata = [];

    panelData && panelData.trendData && Array.isArray(panelData.trendData) && panelData.trendData.map((data) => {
      data = {
        ...data,
        DateTime: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
      };

      legendsdata.push({
        name: data.Description,
        icon: "roundRect",
        textStyle: {
          fontSize: 16,
          color: props.theme === 'dark' ? 'white' : 'black'
        },
      });
      if (!xaxis.includes(data.DateTime)) {
        xaxis.push(data.DateTime);
      }
      if (series.filter((e) => e.value !== "null").map((data) => data.name).includes(data.Name)) {
        let index = series.map((data) => data.name).indexOf(data.Name);
        if (
          (panelData &&
            panelData.tunedData &&
            panelData.tunedData.CodeType &&
            panelData.tunedData.CodeType === 'Asset') ||
          selectedType === 'Asset'
        ) {

          series[index].data.push([
            data.DateTime,
            data.Value,
            data.ParameterCode,
            data.AssetCode
          ]);
        } else {
          series[index].data.push([
            data.DateTime,
            data.Value,
            data.ParameterCode,
            data.DeviceCode
          ]);
        }

      } else {
        let obj = {};
        if (
          (panelData &&
            panelData.tunedData &&
            panelData.tunedData.CodeType &&
            panelData.tunedData.CodeType === 'Asset') ||
          selectedType === 'Asset'
        ) {

          obj = {
            dataobj: data,
            name: data.Name,
            data: [[data.DateTime, data.Value, data.ParameterCode, data.AssetCode]],
            type: graphType && graphType !== 'Area' ? graphType : 'line',
            ...(graphType && graphType === 'Area' ? { areaStyle: {} } : {})
          };
        } else {
          obj = {
            dataobj: data,
            name: data.Name,
            data: [[data.DateTime, data.Value, data.ParameterCode, data.DeviceCode]],
            type: graphType && graphType !== 'Area' ? graphType : 'line',
            ...(graphType && graphType === 'Area' ? { areaStyle: {} } : {})
          };
        }

        series.push(obj);
      }
      return {};
    });
    xaxis.sort((a, b) => {
      return new Date(a) - new Date(b);
    });
    let seriesDataObject = series && Array.isArray(series) && series.map((seriesData) => {
      let DataVal = { ...seriesData };
      delete DataVal.dataobj;
      if (
        (panelData &&
          panelData.tunedData &&
          panelData.tunedData.CodeType &&
          panelData.tunedData.CodeType === 'Asset') ||
        selectedType === 'Asset'
      ) {

        return {
          ...DataVal,
          // name: translation(seriesData.name)
          name: `${translation(seriesData.dataobj.Description)}`
        };
      } else {
        return {
          ...DataVal,
          // name: translation(seriesData.name)
          name: `${translation(seriesData.dataobj.Description)}`
        };
      }
    });

    option.xAxis.data = xaxis;
    option.series = seriesDataObject;
    option.legend = [...legendsdata];
    setOption(option);

    let reportData = panelData.trendData && Array.isArray(panelData.trendData) && panelData.trendData.map((data) => {
      if (
        (panelData &&
          panelData.tunedData &&
          panelData.tunedData.CodeType &&
          panelData.tunedData.CodeType === 'Asset') ||
        selectedType === 'Asset'
      ) {

        return {
          // ...data,
          [translation('DateTime')]: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
          [translation('Name')]: `${translation(data.ParameterName)} (${translation(
            data.AssetName
          )})`,
          [translation('Value')]: translation(data.Value),
          [translation('Description')]: `${translation(
            data.Description
          )}`,
          [translation('AssetName')]: translation(data.AssetName),
          [translation('ParameterName')]: translation(data.ParameterName),
          val: translation(data.ParameterName)
        };
      } else {
        return {
          // ...data,
          [translation('DateTime')]: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
          [translation('Name')]: `${translation(data.ParameterName)} (${translation(
            data.DeviceName
          )})`,
          [translation('Value')]: translation(data.Value),
          [translation('Description')]: `${translation(
            data.Description
          )}`,
          [translation('DeviceName')]: translation(data.DeviceName),
          [translation('ParameterName')]: translation(data.ParameterName),
          val: translation(data.ParameterName)
        };
      }

    });
    let reportName = {};
    if (panelData && panelData.tunedData) {
      let { Type } = panelData;
      let From = dayjs().format('YYYY-MM-DD HH:mm:ss');
      let To = dayjs().format('YYYY-MM-DD HH:mm:ss');
      let { FromDate, ToDate, FromDate1, ToDate1, FromDate2, ToDate2 } = panelData.tunedData;
      if (Type === 'timeRange' && panelData.trendIndex === 0) {
        From = FromDate1;
        To = ToDate1;
      } else if (Type === 'timeRange' && panelData.trendIndex === 1) {
        From = FromDate2;
        To = ToDate2;
      } else {
        From = FromDate;
        To = ToDate;
      }
      let value = reportData && Array.isArray(reportData) && reportData[0] && reportData[0].val ? reportData[0].val : "";
      reportData = reportData.map((report) => {
        delete report.val;
        return {
          ...report,
        };
      });

      reportName = await getReportNametoDownload(reportData, panelData.Type, viewType, { From, To }, panelData.trendIndex, value);
    }
    // setReportData(ReportData);
    setReportName(reportName.file);
  };


  const getOption = (panelData) => {
    setReportName(reportName);
    let option = {
      title: {},
      grid: { top: 110 },
      color: panelData.colors,
      tooltip: {
        trigger: "axis",
      },
      xAxis: {
        type: "category",
        data: [],
      },
      yAxis: {
        type: "value",
      },
      backgroundColor: props.theme === 'dark' ? 'black' : 'white',
      toolbox: {
        showTitle: false,
        orient: "horizontal",
        itemSize: 25,
        feature: {
          myTool1: {
            show: true,
            title: "custom extension method 1",
            icon: "path://M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z",
            onclick: () => {
              if (reportName) {
                downLoadExcel(reportName);
              } else {
                console.error('reportName is not defined data1');
              }
            }
          },
          saveAsImage: {
            title: "download",
            name: props.graphprops ? props.graphprops.title : "name",
          },
        },
      },
      dataZoom: [
        {
          type: "slider",
          show: true,
          start: 0,
          end: 100,
          backgroundColor: "#9a9191",
        },
        {
          type: "inside",
          start: 0,
          end: 100,
        },
      ],
      series: {
        name: "value",
        type: graphType,
        data: [],
      },
    };
    return option;
  };

  const downLoadExcel = (file) => {
    const link = document.createElement("a");
    link.href = `${IPAddress.LOCAL}${REPORTS.Reports}/${file}`;
    link.setAttribute("download", reportName);
    document.body.appendChild(link);
    link.click();
  };

  const onChartClick = (cellData) => {
    setCeld(cellData);
    getModal(cellData);
  };

  const getModal = async (cellData) => {
    let ToDate = cellData.data[0];
    let FromDate = dayjs(cellData.data[0]).subtract(1, "days").format("YYYY-MM-DD HH:mm:ss");
    // setRange([FromDate, ToDate]);
    const siteId = localStorage.get("currentSite");
    const accessToken = localStorage.get("accessToken");
    let payload = {};

    if (
      (panelData &&
        panelData.tunedData &&
        panelData.tunedData.CodeType &&
        panelData.tunedData.CodeType === 'Asset') ||
      selectedType === 'Asset'
    ) {
      payload = {
        ParameterList: [
          {
            ParameterCode: cellData.data[2],
            AssetCode: cellData.data[3],
            ParameterValue: cellData.data[1]
          }
        ],
         CodeType: panelData &&
          panelData.tunedData &&
          panelData.tunedData.CodeType ?
          panelData.tunedData.CodeType : 'Asset',
        ToDate,
        FromDate,
        SiteId: siteId
      };
    } else {
      payload = {
        ParameterList: [
          {
            ParameterCode: cellData.data[2],
            DeviceCode: cellData.data[3],
            ParameterValue: cellData.data[1]
          }
        ],
        CodeType: panelData &&
          panelData.tunedData &&
          panelData.tunedData.CodeType ?
          panelData.tunedData.CodeType : 'Device',
        ToDate,
        FromDate,
        SiteId: siteId
      };
    }
    const headers = {
      method: "POST",
      url: `${API_TRENDS.GetParametersData}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: payload
    };
    axios(headers)
      .then((response) => {
        setDatasource(response.data);
      })
      .catch(() => { });
    setVisible(true);
  };

  const onChange = (value, dateString) => {
    // setRange([dateString[0], dateString[1]]);
    setMomentRange([dayjs(dateString[0]), dayjs(dateString[1])]);
  };

  const disabledDate = (current) => {
    return current > dayjs().endOf("day");
  };

  const onhandleRangepicker = () => {
    let cellData = celd;
    getModal(cellData);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  let { panelData } = props;
  const DeviceColumns = [
    {
      title: translation('Device Name'),
      dataIndex: 'DeviceName',
      key: 'DeviceName'
    },
    {
      title: translation('Parameter Name'),
      dataIndex: 'ParameterName',
      key: 'ParameterName'
    },
    {
      title: translation('Parameter Value'),
      dataIndex: 'ParameterValue',
      key: 'ParameterValue'
    },
    {
      title: translation('TimeStamp'),
      dataIndex: 'DateTime',
      key: 'DateTime',
      render: (text) => {
        if (text) {
          return dayjs(text).local().format('YYYY-MM-DD HH:mm:00');
        }
      }
    }
  ];
  const AssetColumns = [
    {
      title: translation('Asset Name'),
      dataIndex: 'AssetName',
      key: 'AssetName'
    },
    {
      title: translation('Parameter Name'),
      dataIndex: 'ParameterName',
      key: 'ParameterName'
    },
    {
      title: translation('Parameter Value'),
      dataIndex: 'ParameterValue',
      key: 'ParameterValue'
    },
    {
      title: translation('TimeStamp'),
      dataIndex: 'DateTime',
      key: 'DateTime',
      render: (text) => {
        if (text) {
          return dayjs(text).local().format('YYYY-MM-DD HH:mm:ss');
        }
      }
    }
  ];

  let onEvents = {
    click: (cellData) => onChartClick(cellData),
  };
  return (
    <React.Fragment>
      <Drawer
        open={visible}
        title="Historic Trend"
        width={1200}
        onOk={handleOk}
        onClose={handleCancel}
        footer={null}
      >
        <RangePicker
          style={{ width: 350, float: "right" }}
          showTime={{ format: "HH:mm:ss" }}
          format="YYYY-MM-DD HH:mm:ss"
          placeholder={["Start DateTime", "End DateTime"]}
          value={momentRange}
          onChange={onChange}
          onOk={onhandleRangepicker}
          disabledDate={disabledDate}
        />
        {(panelData &&
          panelData.tunedData &&
          panelData.tunedData.CodeType &&
          panelData.tunedData.CodeType === 'Asset') ||
          selectedType === 'Asset' ? (
          <StyledTable size="small" dataSource={datasource} columns={AssetColumns} />
        ) : (
          <StyledTable size="small" dataSource={datasource} columns={DeviceColumns} />
        )}
      </Drawer>
      {option && option.series && Array.isArray(option.series) && option.series.length > 0 ? (
        <ReactEcharts
          option={option}
          onEvents={
            panelData.Type === "historic" && panelData.parameterType === "Operational"
              ? onEvents
              : null
          }
          notMerge={true}
          lazyUpdate={true}
          style={{ height: "50%", width: "100%", backgroundColor: `${props.theme}` === 'dark' ? 'black' : 'white' }}
          className="react_for_echarts"
        />
      ) : (
        <NoRecordComponent />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  theme: state.ThemeReducer.algorithm,
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone,
});

export default connect(mapStateToProps)(Line);